import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import currencyFormatter from 'currency-formatter';
import moment from 'moment';

const PaymentHistory = observer(class PaymentHistory extends React.Component {
  componentWillMount() {
    this.props.store.PaymentStore.getPaymentHistory();
  }

  render() {
    const { translation } = this.props;
    const { paymentHistory } = this.props.store.PaymentStore;

    if(paymentHistory.length > 0) {
      return (
        <table>
          <thead>
            <tr>
              <th id="heading-date" className="subtitle" scope="col">{translation.date}</th>
              <th id="heading-type" className="subtitle" scope="col">{translation.type}</th>
              <th id="heading-check" className="subtitle" scope="col">{translation.check}</th>
              <th id="heading-status" className="subtitle" scope="col">{translation.status}</th>
              <th id="heading-amount" className="subtitle" scope="col">{translation.amount}</th>
            </tr>
          </thead>
          <tbody>
            {paymentHistory.map(
              (payment, i) =>
              <tr key={i}>
                <td aria-labelledby="heading-date">
                  {moment(payment.dateInitiated || payment.createdDate).local().tz(moment.tz.guess()).format('M/D/YYYY')}
                </td>
                <td aria-labelledby="heading-date">
                  {payment.paymentType === 'online-check' &&
                    translation.online_check
                  }

                  {payment.paymentType === 'physical-check' &&
                    translation.physical_check
                  }
                  {payment.paymentType === 'ach' &&
                    translation.ach
                  }
                </td>
                <td aria-labelledby="heading-check">
                  
                  {payment.paymentType !== 'ach' && 
                    `#${payment.paymentNumber} `
                  }
                  

                  {payment.paymentType === 'online-check' && !payment.clearedBank &&
                    <a
                      href={payment.pdfUrl}
                      target="_blank"
                    >
                      {translation.view_check}
                    </a>
                  }
                </td>
                <td aria-labelledby="heading-status">
                  {payment.clearedBank && payment.paymentType !== 'ach' &&
                    `${translation.cashed} on ${moment(payment.clearedBank).local().tz(moment.tz.guess()).format('M/D/YYYY')}`
                  }

                  {payment.clearedBank && payment.paymentType === 'ach' &&
                    `${translation.transfered} on ${moment(payment.clearedBank).local().tz(moment.tz.guess()).format('M/D/YYYY')}`
                  }

                  {!payment.clearedBank &&
                    translation.uncashed
                  }
                </td>
                <td aria-labelledby="heading-amount" className="number">
                  {currencyFormatter.format(payment.amount, {code: payment.currencyCode})}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )
    } else {
      return (
        <span className="no-results">{translation.no_history}</span>
      )
    }
  }
})

export default translate('PaymentHistory')(PaymentHistory);


// WEBPACK FOOTER //
// ./src/app/components/Payments/PaymentHistory.js